import { useEffect, useState } from 'react';
import { Flex, Padding } from 'components/base/layout-components';
import Text from 'components/base/Text';

import ValidatingBanner from 'images/validating_sso_configuration_banner.svg';
import InvalidConfigurationBanner from 'images/invalid_sso_configuration_banner.svg';

import Loading from 'images/loading.gif';
import { LBButton } from '@linearb/buzz';

const ValidatingSamlSSOConfiguration = ({
  onSaveSSO,
  onEditClicked,
  testConnectivityRes
}) => {
  const [isValidConfiguration, setIsValidConfiguration] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (testConnectivityRes) {
      setIsLoading(false);
      if (testConnectivityRes !== 'passed') {
        setIsValidConfiguration(false);
      }
    } else {
      (async () => {
        try {
          onSaveSSO();
          setIsValidConfiguration(true);
        } catch (exp) {
          setIsValidConfiguration(false);
        }
        setIsLoading(false);
      })();
    }
  }, []);

  return (
    <Flex direction='column' padding='medium' pt='large'>
      <Padding t='small'>
        <img
          width='100%'
          height='103rem'
          src={
            isValidConfiguration ? ValidatingBanner : InvalidConfigurationBanner
          }
          alt='SSO validation'
        />
      </Padding>
      <Padding t='normal' b='normal'>
        <Text size='x-x-large'>
          {isLoading ? 'Hang on...' : isValidConfiguration ? 'Done' : 'Oops..'}
        </Text>
      </Padding>
      <Padding b='normal'>
        <Text size='large'>
          {isLoading
            ? 'We are still validating your SSO details, should be done in a few seconds'
            : isValidConfiguration
            ? 'Your SSO connection has been validated'
            : 'Unable to validate connection, try editing your configuration input'}
        </Text>
      </Padding>
      {isLoading && (
        <img
          style={{
            width: '5rem',
            height: '4rem'
          }}
          src={Loading}
          alt='Loading'
        />
      )}
      <Padding t='normal' b='normal'>
        {!isLoading && !isValidConfiguration && (
          <LBButton onClick={onEditClicked}>Edit</LBButton>
        )}
      </Padding>
    </Flex>
  );
};

export default ValidatingSamlSSOConfiguration;
